module.exports = __webpack_public_path__ + "static/media/redux.2588443c.ico";